// External dependencies
import React from 'react';

// Internal dependencies
import AdminLayout from './AdminLayout.component';

export default function AdminNewsletter() {
  return (
    <AdminLayout>
      <div className="container">
        <h2>Newsletter subscribers</h2>

        <p>Work in progress.</p>
      </div>
    </AdminLayout>
  );
}

AdminNewsletter.propTypes = {};
